import { render, staticRenderFns } from "./CardTarjaEnqueteSaiaJustaWithQRCode.vue?vue&type=template&id=fc6be8c8&scoped=true"
import script from "./CardTarjaEnqueteSaiaJustaWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSaiaJustaWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSaiaJustaWithQRCode.vue?vue&type=style&index=0&id=fc6be8c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6be8c8",
  null
  
)

export default component.exports